var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    ref: "productSku",
    attrs: {
      "input-delay": 500,
      items: _vm.foundProducts,
      label: _vm.compLabel,
      auto: "",
      "select-on-focus": "",
      fancy: "",
      icon: _vm.icon,
      open: "",
    },
    on: {
      blur: function ($event) {
        return _vm.blur()
      },
      keyup: function ($event) {
        return _vm.keyup($event)
      },
      "icon-click": function ($event) {
        return _vm.iconClicked()
      },
      "item-click": function ($event) {
        return _vm.productSelected($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (p) {
          return [
            _vm._v(" " + _vm._s(p.item.Sku)),
            _c("br"),
            _vm._v(" " + _vm._s(p.item.Name) + " "),
          ]
        },
      },
    ]),
    model: {
      value: _vm.text,
      callback: function ($$v) {
        _vm.text = $$v
      },
      expression: "text",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }